import { supabase } from "../supabaseClient"

const invokeGtmManager = async (body) => {
  const { data, error } = await supabase.functions.invoke("gtm-manager", { body })
  if (error) {
    let payload = null
    if (error.context?.json) {
      try { payload = await error.context.json() } catch (_) {
        // Keep the function client's error message.
      }
    }
    const requestError = new Error(payload?.error || error.message || "GTM request failed")
    requestError.code = payload?.code || null
    requestError.details = payload?.details || null
    throw requestError
  }
  if (data?.error) {
    const requestError = new Error(data.error)
    requestError.code = data.code || null
    requestError.details = data.details || null
    throw requestError
  }
  return data || {}
}

export const listPaidMediaSetups = (organizationId) =>
  invokeGtmManager({ action: "list-setups", organization_id: organizationId })

export const startGtmOAuth = (
  organizationId,
  { purpose = "connect", oauthConnectionId = null } = {},
) => invokeGtmManager({
  action: "oauth-start",
  organization_id: organizationId,
  purpose,
  oauth_connection_id: oauthConnectionId,
})

export const completeGtmOAuth = (organizationId, code, state) =>
  invokeGtmManager({
    action: "oauth-complete",
    organization_id: organizationId,
    code,
    state,
  })

export const listGtmContainers = (organizationId, oauthConnectionId, gtmAccountId) =>
  invokeGtmManager({
    action: "list-containers",
    organization_id: organizationId,
    oauth_connection_id: oauthConnectionId,
    gtm_account_id: gtmAccountId,
  })

export const savePaidMediaSetup = (organizationId, setup) =>
  invokeGtmManager({
    action: "save-setup",
    organization_id: organizationId,
    ...setup,
  })

export const setTaggingProfile = (organizationId, profile) =>
  invokeGtmManager({
    action: "set-profile",
    organization_id: organizationId,
    tagging_profile: profile,
  })

export const discoverTaggingEvents = (organizationId, setupId) =>
  invokeGtmManager({
    action: "discover-events",
    organization_id: organizationId,
    setup_id: setupId,
  })

export const addTaggingEvent = (organizationId, setupId, eventName) =>
  invokeGtmManager({
    action: "add-event",
    organization_id: organizationId,
    setup_id: setupId,
    event_name: eventName,
  })

export const saveEventRoutes = (organizationId, setupId, events) =>
  invokeGtmManager({
    action: "save-routes",
    organization_id: organizationId,
    setup_id: setupId,
    events,
  })

export const resetEventRoutes = (organizationId, setupId) =>
  invokeGtmManager({
    action: "reset-routes",
    organization_id: organizationId,
    setup_id: setupId,
  })

export const resetOrganizationEventRoutes = (organizationId) =>
  invokeGtmManager({
    action: "reset-routes",
    organization_id: organizationId,
  })

export const runGtmConfigurationAudit = (organizationId, setupId) =>
  invokeGtmManager({
    action: "audit-configuration",
    organization_id: organizationId,
    setup_id: setupId,
  })

export const runGtmDependencyAudit = (
  organizationId,
  gtmContainerConnectionId,
  expectedPlatformIds = [],
) => invokeGtmManager({
  action: "audit-dependencies",
  organization_id: organizationId,
  gtm_container_connection_id: gtmContainerConnectionId,
  expected_platform_ids: expectedPlatformIds,
})

export const preflightGtmInstall = (organizationId, setupId) =>
  invokeGtmManager({
    action: "preflight",
    organization_id: organizationId,
    setup_id: setupId,
  })

export const installGtmManifest = (organizationId, setupId) =>
  invokeGtmManager({
    action: "install",
    organization_id: organizationId,
    setup_id: setupId,
  })

export const publishGtmInstallation = (organizationId, setupId, installationId) =>
  invokeGtmManager({
    action: "publish",
    organization_id: organizationId,
    setup_id: setupId,
    installation_id: installationId,
  })
